<!-- Dialog box for template and product Selection -->
<ng-template #templateDialog >
     <div class="dialog-wrapper">
      <div>
      <label i18n="@@CreateStrategy" class="textColourpopup">
        Select Product & Template
      </label>
      <span class="example-spacer"></span>
    </div>

  <mat-dialog-content [formGroup]="templateForm" class="dialog-content">
    <!-- Product Selection -->

    <mat-form-field appearance="outline" class="w-100 mb-4" style="margin-top: 2%;">
  <mat-label>Select Products</mat-label>

  <mat-select
  formControlName="products"
  multiple
  (closed)="clearProductSearch()"
  #sel="matSelect"
  panelClass="custom-select-panel">

  <!-- Search row -->
  <mat-option class="fixed-top-option no-checkbox" [value]="'__search__'" (click)="$event.stopPropagation()" style="height: 45px!important;">
    <div class="select-search-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <input
        [(ngModel)]="productSearchText"
        [ngModelOptions]="{ standalone: true }"
        (input)="filterProducts()"
        placeholder="Search products..."
        autocomplete="off" />
    </div>
  </mat-option>

  <mat-option
    *ngFor="let product of filteredProducts"
    [value]="product.name">
    {{ product.name }}
  </mat-option>

  <!-- OK row -->
  <mat-option class="fixed-bottom-option no-checkbox" [value]="'__ok__'" (click)="$event.stopPropagation()" style="height: 50px!important;">
    <div class="select-footer-box" (click)="$event.stopPropagation()">
       <app-common-button
          label="Ok"
          title="Ok"
          [buttonId]="1111"
          width="80px"
          [critical]="false"
          (clicked)="sel.close()">
        </app-common-button>
    </div>
  </mat-option>
</mat-select>

  <mat-error *ngIf="templateForm.get('products')?.hasError('required')">
    Please select at least one product.
  </mat-error>
</mat-form-field>



<ng-template #noProducts>
  <mat-option disabled>No products found</mat-option>
</ng-template>


  <!-- Template selection (only mode) -->
      <mat-form-field appearance="outline" class="w-100 mb-4">
        <mat-label>Select Product Strategy Template</mat-label>

        <!-- keep using templateName as value if needed; consider using t.templateId instead -->
          <mat-select formControlName="templateId" (selectionChange)="onTemplateSelected($event.value)">
            <ng-container *ngIf="templates?.length > 0; else noTemplates">
              <mat-option *ngFor="let t of templates" [value]="t.templateName">
                {{ t.templateName }}
              </mat-option>
            </ng-container>

            <ng-template #noTemplates>
              <mat-option disabled>No Templates Found</mat-option>
            </ng-template>
          </mat-select>

             <!-- Validation Error -->
    <mat-error *ngIf="templateForm.get('templateId')?.hasError('required')">
      Please select a product strategy template.
    </mat-error>

      </mat-form-field>

      <ng-template #noTemplates>
        <mat-option disabled>No Templates Found</mat-option>
      </ng-template>
    </mat-dialog-content>


  <mat-dialog-actions align="end"  class="dialog-actions">
    <!-- <button mat-button mat-dialog-close>Cancel</button> -->
      <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
         
 
           style="margin-left: 6px;margin-right:6px;"
            mat-dialog-close
          >
 
          </app-common-button>
    <!-- <button mat-raised-button class="animated-button"  [style.background-color]="backgroundColorButton"  (click)="onTemplateDialogNext()">Next</button> -->
     		     <app-common-button
 
          label="Next"
 
          title="Next "
 
         
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onTemplateDialogNext()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
		  
  </mat-dialog-actions>
  </div>
</ng-template>


<!-- Dynamic Html Rendering Based in creating Strategy -->
 <div class="main-container"
    [class.workflow-mode]="templateId && showWorkflow"
     [class.default-mode]="!showWorkflow" *ngIf="!showProductInfoPage">

        <div *ngIf="!showWorkflow" class="label-bar" style="border-bottom: unset;">

  <label
    style="font-size: 18px; font-weight: 500;"
    i18n="@@spmsUserReg"
    class="textColour">
    Product Safety Strategy
  </label>
 <!-- <span class="custom-badge" *ngIf="productMeta">
  <mat-icon class="close-icon" style="cursor: unset;">filter_list</mat-icon>
  {{productMeta.productName}}
  <mat-icon title="Remove Filter" class="close-icon" (click)="removeFilterShowAllRows()">cancel</mat-icon>
</span> -->

<span class="example-spacer"></span>

  <!-- <app-jsignal-nav-links></app-jsignal-nav-links> -->

</div>

<div *ngIf="templateId && showWorkflow" style="margin-top:2%">
  <mat-horizontal-stepper [linear]="true" class="custom-stepper" #stepper>
    <!-- STEP 1: Strategy Info + Activity -->
    <mat-step
      [stepControl]="stepOneFormGroup"
      label="Strategy Info & Activities"
    >
    <!-- <div class="step-scroll-container"> -->
      <form [formGroup]="stepOneFormGroup">
         <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 10px;
          padding: 0 24px 0 24px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: 100%;
           text-align: start;">Create Product Strategy</label>
           <!-- <span class="chip" *ngFor="let p of visibleProducts">{{ p }}</span> -->
           <span class="badge text-bg-secondary" *ngFor="let p of visibleProducts"
           style="box-shadow: none!important;
            color: #ffffff !important;
            background: #169C1A !important;
            margin: 5px!important;
            font-size: 11px!important;
            padding: 5px!important;
            border-radius: 5px!important;margin-left: 0px !important;font-weight: 500;"
           >{{ p }}</span>
           <span *ngIf="hiddenCount > 0" class="badge"
                  matTooltip="{{ allProductsTooltip }}"
                   matTooltipPosition="above"  style="box-shadow: none!important;
            color: #ffffff !important;
            background: #169C1A !important;
            margin: 5px!important;
            font-size: 11px!important;
            padding: 5px!important;
            border-radius: 5px!important;margin-left: 0px !important;font-weight: 500;">
              +{{ hiddenCount }} more
            </span>
            <div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 0px;padding: 0 24px 0 24px;">
        <div class="col-lg-4">
          <mat-form-field
            #strategyNameField="matFormField"
            appearance="outline"
            class="w-100"
          >
            <mat-label
              >Strategy Name <span class="text-danger"></span
            ></mat-label>
            <input matInput formControlName="templateName" />
            <mat-error
              *ngIf="stepOneFormGroup.get('templateName')?.hasError('required')"
            >
              Strategy Name is required
            </mat-error>
          </mat-form-field>
        </div>
         <div class="col-lg-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Level</mat-label>
            <mat-select formControlName="level" required>
              <mat-option *ngFor="let lvl of levels" [value]="lvl.lookupvalue">
                {{ lvl.lookupvalue }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="stepOneFormGroup.get('level')?.hasError('required')">
              Level is required
            </mat-error>
          </mat-form-field>
         </div>
        </div>
        <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 0px;padding: 0 24px 0 24px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: 100%;
           text-align: start;">Document Renew Period</label>
        </div>
        <div class="row" style="padding: 0 24px 0 24px;">
        <div class="col-lg-8">
          <mat-form-field appearance="outline">
                <mat-label>Select Schedule</mat-label>
                <input matInput type="text" formControlName="selectschedule" (click)="selectSchedulerClick()" [(ngModel)]="selectSchedule" required readonly>
                    <mat-error
                     *ngIf="stepOneFormGroup.get('selectschedule')?.hasError('required')"
                    >
                    Schedule  is required
                  </mat-error>
              </mat-form-field>
          </div>
          </div>
          <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 0px;padding: 0 24px 0 24px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: 100%;
           text-align: start;">PSS Review Period</label>
        </div>
        <div class="row" style="padding: 0 24px 0 24px;">
        <div class="col-lg-4">
          <mat-form-field appearance="outline">
                <mat-label>Every</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pssReviewNumber"
                  min="0"
                />
              </mat-form-field>
          </div>
          <div class="col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Period</mat-label>
                <mat-select formControlName="pssReviewPeriod">
                  <mat-option value="Days">Days</mat-option>
                  <mat-option value="Weeks">Weeks</mat-option>
                  <mat-option value="Months">Months</mat-option>
                </mat-select>
              </mat-form-field>
          </div>
          </div>
          <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 0px;padding: 0 24px 0 24px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: 100%;
           text-align: start;">PSS Approval Period</label>
        </div>
        <div class="row" style="padding: 0 24px 0 24px;">
        <div class="col-lg-4">
          <mat-form-field appearance="outline">
                <mat-label>Every</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pssApprovalNumber"
                  min="0"
                />
              </mat-form-field>
          </div>
          <div class="col-lg-4">
             <mat-form-field appearance="outline">
                <mat-label>Period</mat-label>
                <mat-select formControlName="pssApprovalPeriod">
                  <mat-option value="Days">Days</mat-option>
                  <mat-option value="Weeks">Weeks</mat-option>
                  <mat-option value="Months">Months</mat-option>
                </mat-select>
              </mat-form-field>
          </div>
          </div>
           <div  class="row topRowMargins" style="margin-bottom: 2%;">

        <div class="col-lg text-center" >
          <div style="text-align: start">

          </div>
            <div style="text-align: end">
               <!-- <button i18n="@@TargetCancel" type="button" (click)="cancelWorkflow()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->

    
		     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="cancelWorkflow()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

                    <!-- <button  i18n="@@TargetClear" type="button" (click)="goToStepTwo(stepper)"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Next</button> -->

    		     <app-common-button
 
          label="Next"
 
          title="Next "
 
          
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="goToStepTwo(stepper)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>


            </div>
 
        </div>
        
    </div>
        <div class="container" *ngIf="false">
        
          

          <!-- Doc Section -->
          <div *ngIf="showDocumentSections">
            <h5 class="text-primary">Document Section</h5>

            <div style="margin-top: 2rem"></div>

            <!-- Activity Settings -->
            <div class="row g-3 mb-4 w-100">
              <div class="col-md-12 w-100">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select Activity </mat-label>
                  <mat-select
                    formControlName="activities"
                    multiple
                    (closed)="clearActivitySearch()"
                  >
                    <!-- Wrapped search input inside mat-form-field -->
                    <mat-option [disabled]="true" class="search-input-option">
                      <mat-form-field class="w-100 m-0">
                        <input
                          matInput
                          placeholder="Search activities..."
                          [(ngModel)]="activitySearchText"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="filterActivities()"
                          (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()"
                          name="searchActivity"
                          autocomplete="off"
                        />
                      </mat-form-field>
                    </mat-option>

                    <!-- Filtered list -->
                    <ng-container
                      *ngIf="filteredActivities.length > 0; else noActivities"
                    >
                      <mat-option
                        *ngFor="let activity of filteredActivities"
                        [value]="activity.lookupvalue"
                      >
                        {{ activity.lookupvalue }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>

                <ng-template #noActivities>
                  <mat-option disabled>No activities found</mat-option>
                </ng-template>
              </div>

              <!-- <div class="col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Due Days</mat-label>
              <input matInput type="number" formControlName="dueDays" />
            </mat-form-field>
          </div> -->
            </div>

            <div
              formArrayName="sections"
              class="mt-4"
              cdkDropList
              [cdkDropListData]="stepOneSections.controls"
              (cdkDropListDropped)="onSectionReorder($event)"
            >
              <div
                *ngFor="let sec of stepOneSections.controls; let i = index"
                [formGroupName]="i"
                class="p-3 mb-2 border rounded"
                cdkDrag
              >
                <!-- drag handle optional -->
                <div
                  cdkDragHandle
                  class="drag-handle mb-2"
                  style="cursor: grab"
                >
                  <mat-icon>drag_handle</mat-icon>
                </div>
                <!-- title + remove -->
                <ng-container [ngSwitch]="sec.get('type').value">
                  <div class="d-flex mb-2">
                    <mat-form-field appearance="outline" class="flex-grow-1">
                      <mat-label>Title</mat-label>
                      <input matInput formControlName="title" />
                    </mat-form-field>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="removeStepOneSection(i)"
                    >
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </div>

                  <!-- conditional Signal Detection block… -->
                  <ng-container *ngSwitchCase="'Text'">
                    <ng-container
                      *ngIf="
                        sec.get('title')?.value ===
                        'Signal Detection and Management'
                      "
                    >
                      <!-- … your dropdown + textarea … -->
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Signal Sources</mat-label>
                        <mat-select formControlName="signalSources" multiple>
                          <mat-option
                            *ngFor="let src of SignalSources"
                            [value]="src.lookupvalue"
                          >
                            {{ src.lookupvalue }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Tools & Methods</mat-label>
                        <textarea
                          matInput
                          formControlName="toolsMethods"
                          rows="2"
                        ></textarea>
                      </mat-form-field>
                    </ng-container>
                  </ng-container>

                  <!-- TEXT SECTION -->
                  <ng-container *ngSwitchCase="'Text'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Description</mat-label>
                      <textarea
                        matInput
                        formControlName="description"
                        rows="3"
                      ></textarea>
                    </mat-form-field>
                  </ng-container>

                  <!-- TABLE SECTION (new) -->
                  <ng-container *ngSwitchCase="'Table'">
                    <!-- column headers -->
                    <div formArrayName="columns" class="d-flex mb-2">
                      <div
                        *ngFor="
                          let colCtrl of sec.get('columns').controls;
                          let ci = index
                        "
                        class="me-2"
                      >
                        <mat-form-field appearance="outline">
                          <mat-label>Header {{ ci + 1 }}</mat-label>
                          <input matInput [formControlName]="ci" />
                        </mat-form-field>
                      </div>
                    </div>
                    <!-- table body -->
                    <div formArrayName="rows">
                      <div
                        *ngFor="
                          let row of sec.get('rows').controls;
                          let ri = index
                        "
                        [formGroupName]="ri"
                        class="d-flex mb-2"
                      >
                        <div
                          *ngFor="let cell of row.controls; let ci = index"
                          class="me-2"
                        >
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Cell {{ ri + 1 }}–{{ ci + 1 }}</mat-label
                            >
                            <input matInput [formControlName]="ci" />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <!-- ADD BUTTON now simply calls addStepOneSection() -->
              <!-- Add Section button -->
              <!-- <button mat-stroked-button
        [style.background-color]="backgroundColorButton"
        [matMenuTriggerFor]="addSectionMenu">
  <mat-icon>add</mat-icon> Add Section
</button> -->

              <mat-menu #addSectionMenu="matMenu">
                <button mat-menu-item (click)="addStepOneSection()">
                  <mat-icon>notes</mat-icon>
                  <span>Text Section</span>
                </button>
                <button
                  mat-menu-item
                  [matMenuTriggerFor]="tableSizeMenu"
                  #tableSizeTrigger="matMenuTrigger"
                >
                  <mat-icon>table_chart</mat-icon>
                  <span>Table Section</span>
                </button>
              </mat-menu>

              <mat-menu #tableSizeMenu="matMenu" class="p-2">
                <div class="table-size-picker">
                  <div class="grid">
                    <div
                      *ngFor="let _r of tableGrid; let i = index"
                      class="grid-row"
                    >
                      <div
                        *ngFor="let _c of tableGrid; let j = index"
                        class="grid-cell"
                        [class.selected]="i < tableRows && j < tableCols"
                        (mouseenter)="onGridHover(i + 1, j + 1)"
                        (click)="
                          addTableSection(tableRows, tableCols);
                          tableSizeTrigger.closeMenu()
                        "
                      ></div>
                    </div>
                  </div>
                  <div class="picker-label">
                    {{ tableRows }} × {{ tableCols }}
                  </div>
                </div>
              </mat-menu>
            </div>
          </div>

          <!-- Back  -->
          <button
            mat-stroked-button
            class="animated-button"
            [style.background-color]="backgroundColorButton"
            (click)="cancelWorkflow()"
            style="margin-top: 2rem"
          >
            Back to Grid
          </button>
          <div class="d-flex justify-content-end mt-3">
            <!-- NEXT Button -->
            <button
              mat-raised-button
              class="animated-button"
              [style.background-color]="backgroundColorButton"
              (click)="goToStepTwo(stepper)"
            >
              Next
            </button>
          </div>
        </div>
      </form>
      <!-- </div> -->
    </mat-step>

    <!-- STEP 2: Evidence, Access Control per Activity -->
    <mat-step [stepControl]="stepTwoFormArray" label="Activity Configuration">
    <!-- <div class="step-scroll-container"> -->
      <form [formGroup]="stepTwoFormGroup">

        <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 10px;
          margin-bottom: 0px;
          padding: 0 24px 0 24px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: 100%;
           text-align: start;">Activity Configurations</label>
           <!-- <span class="chip" *ngFor="let p of visibleProducts">{{ p }}</span> -->
           <span class="badge text-bg-secondary" *ngFor="let p of visibleProducts"
           style="box-shadow: none!important;
            color: #ffffff !important;
            background: #169C1A !important;
            margin: 5px!important;
            font-size: 11px!important;
            padding: 5px!important;
            border-radius: 5px!important;margin-left: 0px !important;font-weight: 500;"
           >{{ p }}</span>
           <span *ngIf="hiddenCount > 0" class="badge"
                  matTooltip="{{ allProductsTooltip }}"
                   matTooltipPosition="above"  style="box-shadow: none!important;
            color: #ffffff !important;
            background: #169C1A !important;
            margin: 5px!important;
            font-size: 11px!important;
            padding: 5px!important;
            border-radius: 5px!important;margin-left: 0px !important;font-weight: 500;">
              +{{ hiddenCount }} more
            </span>
        </div>
        <div style="background-color:   #D9D9D9;">
          <div class="row">
             <div
            formArrayName="activityConfigs"
            cdkDropList
            [cdkDropListData]="activityControls"
            (cdkDropListDropped)="onActivityReorder($event)"
            class="draggable-container"
            class="col-lg-12"
          >
          <div class="row" style="width: 100%;margin: 0;">
              <div
                  *ngFor="let ctrl of activityControls; let i = index"
                  [formGroupName]="i"
                  class="col-lg-12"
                  cdkDrag
                  style="background: white;margin-top:5px;"
                >
                <div class="row topRowMargins headerStyle" style="
                  margin-right: 0;
                  margin-left: 0; 
                  margin-top: 10px;
                  margin-bottom: 0px;border:none;
                ">
                  <div cdkDragHandle class="drag-handle mb-2" style="cursor: grab">
                    <mat-icon>drag_indicator</mat-icon>
                  </div>
                    <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;width: fit-content;
                    text-align: start;">For "{{ selectedActivities[i] }}"</label>
                  </div>
                  <div class="row">
                      <div class="col-lg-3">
                        <!--  NEW: Level Dropdown -->
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Level</mat-label>
                          <mat-select formControlName="level" [disabled]="true">
                            <mat-option
                              *ngFor="let lvl of levels"
                              [value]="lvl.lookupvalue"
                            >
                              {{ lvl.lookupvalue }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="ctrl.get('level')?.hasError('required')">
                          Level is required
                        </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                          <!-- REVIEW PERIOD -->
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Review Period</mat-label>
                            <mat-select formControlName="reviewPeriod">
                              <mat-option
                                *ngFor="let period of reviewPeriods"
                                [value]="period"
                              >
                                {{ period }}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="ctrl.get('reviewPeriod')?.hasError('required')">
                            Review Period is required
                          </mat-error>
                          </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                          <!-- DUE DAYS -->
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Due Days</mat-label>
                            <input matInput type="number" formControlName="dueDays" />
                            <mat-error *ngIf="ctrl.get('dueDays')?.hasError('required')">
                            Due Days is required
                          </mat-error>
                          <mat-error *ngIf="ctrl.get('dueDays')?.hasError('min')">
                            Due Days must be greater than or equal to 1
                          </mat-error>
                          </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <!-- START DATE -->
                        <mat-form-field appearance="outline">
                          <mat-label>Start Date</mat-label>
                          <input
                            matInput
                            [matDatepicker]="picker"
                            [min]="minDate"
                            formControlName="startDate"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="ctrl.get('startDate')?.hasError('required')">
                          Start Date is required
                        </mat-error>
                        </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-lg-3">
                        <mat-form-field appearance="outline" class="flex-fill">
                          <mat-label>Duration in Hours</mat-label>
                          <input
                            matInput
                            type="number"
                            min="0"
                            formControlName="durationHours"
                          />
                        <mat-error *ngIf="ctrl.get('durationHours')?.hasError('required')">
                        Duration is required
                      </mat-error>
                        <mat-error *ngIf="ctrl.get('durationHours')?.hasError('min')">
                        Duration must be greater than or equal to 1
                      </mat-error>
                        </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Upload Instructions</mat-label>
                              <input matInput formControlName="uploadInstructions" />
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg-3">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Roles Allowed</mat-label>
                            <mat-select formControlName="rolesAllowed" multiple>
                              <mat-option
                                *ngFor="let option of Accesstypes" [value]="option[1]"
                                >{{  option[1] }}</mat-option
                              >
                            </mat-select>
                            <mat-error *ngIf="ctrl.get('rolesAllowed')?.hasError('required')">
                            Roles Allowed  is required
                          </mat-error> 
                          </mat-form-field>
                        </div> -->
                        <div class="col-lg-3">
                          <mat-label class="mt-2">Is Evidence Required?</mat-label>
                            <mat-radio-group
                              formControlName="evidenceRequired"
                              class="d-flex flex-row gap-4"
                              style="gap: 1rem"
                            >
                              <mat-radio-button value="Yes">Yes</mat-radio-button>
                              <mat-radio-button value="No">No</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-9">
                     <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Activity Description</mat-label>
                        <textarea
                          matInput
                          formControlName="activitydescripition"
                          placeholder="Enter description"
                          rows="3">
                        </textarea>
                            <mat-error *ngIf="ctrl.get('activitydescripition')?.hasError('specialCharacter')">
                            Special characters are not allowed
                          </mat-error>
                      </mat-form-field>

                      </div>
                    </div>
                </div>
          </div>
          </div>
          </div>
        </div>
          <div  class="row topRowMargins" style="margin-bottom: 2%;">
        <div class="col-lg text-center" >
          <div style="text-align: start">

          </div>
            <div style="text-align: end">
               <!-- <button i18n="@@TargetCancel" type="button" (click)="stepper.previous()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
                      padding-left: 1.2rem;
                      padding-right: 1.2rem;
                      width: 10%;
                      box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->
          <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="stepper.previous()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

                    <!-- <button  i18n="@@TargetClear" type="button" (click)="goToStepThree(stepper)"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
                    padding-left: 1.2rem;
                    padding-right: 1.2rem;
                    width: 10%;
                    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Next</button> -->

        <app-common-button
 
          label="Next"
 
          title="Next "
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="goToStepThree(stepper)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
		  
            </div>
        </div>
        
    </div>
      </form>
      <!-- </div> -->
    </mat-step>
    <!-- STEP 3: Preview -->
    <mat-step label="Preview & Submit">
    <!-- <div class="step-scroll-container"> -->
       <div class="preview-container" [@pageFlip]="flipState">
          <div class="row topRowMargins headerStyle" style="
              margin-right: 0;
              margin-left: 0; 
              margin-top: 10px;
              margin-bottom: 0px;
              padding: 0 24px 0 24px;
              ">
              <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;
              text-align: start;" *ngFor="
            let name of previewData
              | slice
                : currentProductPage * pageSize
                : (currentProductPage + 1) * pageSize
          ">{{ name.product }}</label>
          <span class="example-spacer"></span>
                <div class="paginationButtons" style="border: 1px solid black;">
                  <ul class="pagination-container">
                    <li class="pagination-item" style="border-right: 1px solid black;
                    border-radius: unset;"  [class.disabledPagination]="currentProductPage == 0" (click)="onPageChangeEvent(currentProductPage - 1)">
                      <em class="fas fa-angle-left"></em>
                    </li>

                    <li class="pagination-text">{{currentProductPage + 1}} / {{previewData.length}}</li>

                    <li class="pagination-item" style="border-left: 1px solid black;
                    border-radius: unset;" [class.disabledPagination]="currentProductPage+1 == previewData.length" (click)="onPageChangeEvent(currentProductPage + 1)">
                      <em class="fas fa-angle-right"></em>
                    </li>
                  </ul>
                </div>

            </div>
            <div style="background-color:   #D9D9D9;padding-top:1px">
              <ng-container *ngFor=" let a of previewData | slice : currentProductPage * pageSize
                : (currentProductPage + 1) * pageSize " >
                  <mat-expansion-panel *ngIf="a.doc as doc"  class="CreateExpansion" [expanded]="true"
                                style="border-radius:unset;box-shadow: none;margin-top: 5px;">
                    <mat-expansion-panel-header style="background: 'white';border-bottom: '1px solid #a9a9a9a8';
                          max-height: '60px';">
                      <mat-panel-title style="display: grid;">
                          <label
                            style="font-size: 18px; font-weight: 500;margin:auto;width:100%"
                            i18n="@@spmsUserReg"
                            class="textColour"
                            >Document Control </label>
                            <span style="font-size: 12px;
    color: #737070;font-weight: 500;">Version : {{doc.version}} </span>
                          <span class="example-spacer"></span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div style="padding: 0 24px;margin-top: 15px;">
                        <div class="row">
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Title</mat-label>
                              <input matInput [value]="doc.name" readonly />
                            </mat-form-field>
                          </div>
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Created Date</mat-label>
                              <input matInput [value]=" doc.CreatedDate" readonly />
                            </mat-form-field>
                          </div>
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Author</mat-label>
                              <input matInput [value]="doc.author" readonly />
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Reviewers</mat-label>
                              <input matInput [value]="doc.reviewers || '—'" readonly />
                            </mat-form-field>
                          </div>
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Approver</mat-label>
                              <input matInput [value]=" doc.approver || '—'" readonly />
                            </mat-form-field>
                          </div>
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Status</mat-label>
                              <input matInput [value]="doc.status || '—'" readonly />
                            </mat-form-field>
                          </div>
                        </div>
                         <div class="row">
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Level</mat-label>
                              <input matInput [value]="doc.level || '—'" readonly />
                            </mat-form-field>
                            </div>
                             <div class="col-lg-8">
                              <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Document Renew Period</mat-label>
                              <input matInput [value]="doc.renewalPeriodSchedulerId || '—'" readonly />
                            </mat-form-field>

                             </div>
                        </div>
                      </div>
                      </mat-expansion-panel>
                        <mat-expansion-panel *ngIf="a.doc as doc"  class="CreateExpansion" [expanded]="true"
                                style="border-radius:unset;box-shadow: none;margin-top: 5px;">
                    <mat-expansion-panel-header style="background: 'white';border-bottom: '1px solid #a9a9a9a8';
                          max-height: '50px';">
                      <mat-panel-title>
                          <label
                            style="font-size: 18px; font-weight: 500;margin:auto;width: 100%;"
                            i18n="@@spmsUserReg"
                            class="textColour"
                            >Product Overview</label>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div style="padding: 0 24px;margin-top: 15px;margin-bottom: 15px;">
                        <table class="custom-table" style="width: 50%;">
                            <tbody>
                              <tr *ngFor="let prop of objectKeys(a.productOverview); let i = index"  [ngClass]="{ 'even-row-without-header': i % 2 === 0, 'odd-row-without-header': i % 2 !== 0 }">
                                <td style="padding:5px;padding-left: 15px;font-weight: 500;">{{  getOverviewOfEachSelectedProduct(prop) }}</td>
                                <td style="padding:5px;padding-left: 15px;">{{ a.productOverview[prop] }}</td>
                              </tr>
                            </tbody>
                          </table>
                      </div>
                      </mat-expansion-panel>
                      

                  <mat-expansion-panel *ngIf="a.doc as doc"  class="CreateExpansion" [expanded]="true"style="border-radius:unset;box-shadow: none;margin-top: 5px;">
                    <mat-expansion-panel-header style="background: 'white';border-bottom: '1px solid #a9a9a9a8';
                          max-height: '50px';">
                      <mat-panel-title>
                          <label
                            style="font-size: 18px; font-weight: 500;margin:auto;width: 100%;"
                            i18n="@@spmsUserReg"
                            class="textColour"
                            >Activities</label>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div style="padding: 0 24px;margin-top: 15px;">
                        <div *ngFor="let act of a.activityDetails" style="margin-bottom: 3%;">
                          <div  class="row topRowMargins headerStyle" style="
                            margin-right: 0;
                            margin-left: 0; 
                            margin-top: 10px;border: none;
                            ">
                            <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">{{act.activity}}</label>
                          </div>
                          <div class="row" style="padding: 0 12px;">
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Start Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.startDate | date : "dd-MMM-yyyy" }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Level</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.level }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Due Days</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.dueDays }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Review Period</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.reviewPeriod}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Duration</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.durationHours }}h
                  {{ act.durationMinutes }}m {{ act.durationSeconds }}s</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                            <div class="col-lg-2" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Evidence</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.evidenceRequired }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                          <div class="row" style="margin-top: 10px;padding: 0 12px;" >
                            <!-- <div class="col-lg-6" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Roles Allowed</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act.rolesAllowed }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div> -->
                            <div class="col-lg-6" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Instructions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act?.uploadInstructions || "-" }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                          <div class="row" style="margin-top: 10px;padding: 0 12px;">
                            <div class="col-lg-6" style="padding-right: 5px;padding-left: 5px;">
                              <table class="custom-table w-100">
                                  <thead>
                                    <tr style=" background-color: #9d9c9c; color: white;">
                                      <th style="padding:0px;padding-left: 15px;">Activity Description</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="odd-row">
                                      <td style="padding:0px;padding-left: 15px;">{{ act?.activitydescripition || "-" }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                      </div>
                  </mat-expansion-panel>
                   <mat-expansion-panel *ngIf="a.doc as doc"  class="CreateExpansion" [expanded]="true"style="border-radius:unset;box-shadow: none;margin-top: 5px;">
                    <mat-expansion-panel-header style="background: 'white';border-bottom: '1px solid #a9a9a9a8';
                          max-height: '50px';">
                      <mat-panel-title>
                          <label
                            style="font-size: 18px; font-weight: 500;margin:auto;width: 100%;"
                            i18n="@@spmsUserReg"
                            class="textColour"
                            >Document Sections</label>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div style="padding: 0 24px;margin-top: 15px;">
                        <div *ngFor="let sec of a.sections" style="margin-bottom: 3%;">
                          <div  class="row topRowMargins headerStyle" style="
                              margin-right: 0;
                              margin-left: 0; 
                              margin-top: 2%;
                              ">
                              <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">{{ sec.title }}</label>
                            </div>
                            <ng-container *ngIf="sec.type === 'Text'">
                            <p>{{
                              sec.signalSources?.length
                                ? "Sources: " +
                                  sec.signalSources.join(", ") +
                                  "\n\n" +
                                  "Tools & Methods: " +
                                  sec.toolsMethods
                                : sec.description
                            }}</p>
                          </ng-container>
                          <ng-container *ngIf="sec.columns && sec.rows">
                            <table class="custom-table">
                              <thead>
                                <tr style=" background-color: #9d9c9c;color: white;">
                                  <th style="padding:5px;padding-left: 15px;" *ngFor="let col of sec.columns">{{ col || "Column"}}</th>
                                  
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of sec.rows; let i = index"  [ngClass]="{ 'even-row': i % 2 === 0, 'odd-row': i % 2 !== 0 }">
                                  <td style="padding:5px;padding-left: 15px;" *ngFor="let cell of row">{{ cell }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ng-container>
                        </div>
                        </div>
                        </mat-expansion-panel>
                </ng-container>
            </div>
        </div>
        <div  class="row topRowMargins" style="margin-bottom: 2%;">

        <div class="col-lg text-center" >
          <div style="text-align: start">

          </div>
          <div style="text-align: center">
            <div class="paginationButtons" style="border: 1px solid black;">
                  <ul class="pagination-container">
                    <li class="pagination-item" style="border-right: 1px solid black;
                    border-radius: unset;"  [class.disabledPagination]="currentProductPage == 0" (click)="onPageChangeEvent(currentProductPage - 1)">
                      <em class="fas fa-angle-left"></em>
                    </li>

                    <li class="pagination-text">{{currentProductPage + 1}} / {{previewData.length}}</li>

                    <li class="pagination-item" style="border-left: 1px solid black;
                    border-radius: unset;" [class.disabledPagination]="currentProductPage+1 == previewData.length" (click)="onPageChangeEvent(currentProductPage + 1)">
                      <em class="fas fa-angle-right"></em>
                    </li>
                  </ul>
                </div>
          </div>
            <div style="text-align: end">
               <!-- <button i18n="@@TargetCancel" type="button" (click)="stepper.previous()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->
    <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="stepper.previous()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
          
     <!-- <button  i18n="@@TargetClear" type="button" (click)="OnSave()"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Save</button> -->

    		     <app-common-button
 
          label="Save"
 
          title="Save "
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="OnSave()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
		  
                    <!-- <button  i18n="@@TargetClear" type="button" (click)="submitFinalForm()"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Submit</button> -->

        		     <app-common-button
 
          label="Submit"
 
          title="Submit "
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="submitFinalForm()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

            </div>
 
        </div>
        
    </div>
    <!-- </div> -->
    </mat-step>
  </mat-horizontal-stepper>
</div>

<!-- This below component used for edit/view the created Product strategy -->
<div *ngIf="ProductStrategyJson && isEditMode" class="review-mode-container">
   <div class="edit-mode-wrapper">
  <!-- Left: Form  Editable For author-->
  <!-- For userRole need to implement based on login -->
  <div class="left-pane">
    <app-stepper-form
      [jsonData]="ProductStrategyJson"
      [role]="userRole"
      [commentCountMap]="commentCountMap"
      [isPreview]="isPreview"
      [pssState]="state"
      [pssID]="pssId"
      (update)="onJsonUpdated($event)"
      (cancel)="onEditCancel($event)"
      (save)="onSaveJson($event)"
      (SubmitDraft)="onDraftSubmit($event)"
      (sectionId)="onSectionChange($event)"
    >
    </app-stepper-form>
  </div>

  <!-- Right: Comments -->
  <div class="right-pane" *ngIf="!isPreview">
    <app-comments
      [strategyId]="productStrategyIdToEdit"
      (action)="handleReviewerAction($event)"
      (cancel)="cancelcommnents($event)"
      [sectionId]="currentSectionId"
      [role]="userRole"
      [commentsData]="allComments"
      [isFirstLoad]="isFirstLoad"
      (commentCounts)="onCommentCountsUpdated($event)"
      [ProductId]="ProductID"
    >
    </app-comments>
  </div>
  </div>
</div>

<!-- click on product safety strategy by default grid will load here  -->
<ng-container *ngIf="!templateId">
  <div style="padding:0px;margin-top: 0;">
    <mat-expansion-panel #panel
  class="CreateExpansion"
  [expanded]="panelOpenState"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  hideToggle
  style="
    border-radius: 0.8vh 0.8vh 0 0;
    box-shadow: none;
   
  "
  >
  <mat-expansion-panel-header
       [ngStyle]="{
        'background': 'rgb(228 227 230 / 41%)',
        'border': '1px solid #a9a9a9a8',
        'max-height': '50px',
        'border-bottom': panelOpenState ?'none': '1px solid #a9a9a9a8',
        'border-radius': panelOpenState ?'5px 5px 0px 0px': '5px'
        }"
    >
     <mat-panel-title>
        <!-- <label
          style="font-size: 18px; font-weight: 500;margin:auto;"
          i18n="@@spmsUserReg"
          class="textColour"
          >Product Safety Strategy</label
        > -->
        <!-- <span class="ellipsis" id="header"
              (click)="$event.stopPropagation(); openColumnsDialog()"
              style="display: block; text-align: center;margin-left: 5px;
    margin-right: 20px;">
            <span style="font-size: 32px; line-height: 32px; cursor: pointer; color: #333;">
                …
            </span>
        </span> -->
        <!-- Column configuration button -->
  <button mat-icon-button 
          class="header-config-btn"
          (click)="$event.stopPropagation(); openColumnsDialog()"
          matTooltip="Select columns to display">
    <mat-icon>tune</mat-icon>
  </button>

        <mat-slide-toggle 
  color="primary"
  [(ngModel)]="showLatestOnly"
   (click)="$event.stopPropagation()"
  (change)="onToggleLatestOnly($event.checked)"
  matTooltip="Show only the latest version of Product Safety Strategy"
  style="transform: scale(1); font-size: 12px; margin-left: 8px; white-space: nowrap;">
  Latest Only
</mat-slide-toggle>
        <span class="example-spacer"></span>
        
      </mat-panel-title>

     

      <!-- <button *ngIf="!selectedRows || selectedRows.length === 0"
          class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Create Strategy"
          (click)="onCreateTemplate($event)"
          style="box-shadow: none;"
        >
          <span class="btn-content">
            <span>Create Strategy</span>
            <em class="fas fa-plus-circle"></em>
          </span>
        </button> -->
        <app-common-button
         *ngIf="!selectedRows || selectedRows.length === 0"
          label="Create Strategy"
 
          title="Create Strategy "
 
          icon="fas fa-plus-circle"
 
          [buttonId]="114"
 
          width="130px"
          [critical]="true"
          (clicked)="onCreateTemplate($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

        <!-- <button *ngIf="selectedRows?.length > 0"
          class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Download Word"
          (click)="onDownloadWord($event)"
          style="box-shadow: none;"
        >
          <span class="btn-content">
            <span>Download Word</span>
            <em class="fas fa-download"></em>
          </span>
        </button> -->
        <app-common-button
         *ngIf="selectedRows?.length > 0"

          label="Download Word"
 
          title="Download Word "
 
          icon="fas fa-download"
 
          [buttonId]="1111"
 
         width="130px"
          [critical]="false"
          (clicked)="onDownloadWord($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

        <!-- <button *ngIf="selectedRows?.length > 0"
          class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Compare"
          (click)="onCompare($event)"
          style="box-shadow: none;"
        >
          <span class="btn-content">
            <span>Compare</span>
             <em class="fas fa-exchange-alt" ></em>
          </span>
        </button> -->
          <app-common-button
        *ngIf="selectedRows?.length > 0"
          label="Compare"
 
          title="Compare "
 
          icon="fas fa-exchange-alt"
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onCompare($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
        <!-- Download Button -->
        <!-- <button
          class="slim-button download-btn btn btn-rounded-button  waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Download"
          (click)="onDownloadHistory($event)"
          style="box-shadow: none;"
        >
          <span class="btn-content">
            <span>Download</span>
            <em class="fas fa-download"></em>
          </span>
        </button> -->

        <app-common-button
 
          label="Download"
 
          title="Download "
 
          icon="fas fa-download"
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onDownloadHistory($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

        <!-- Refresh Button -->
        <!-- <button
          class="slim-button download-btn popup gridColour btn btn-rounded-button waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Refresh"
          (click)="onRefresh($event)"
          style="margin-right: 1%;box-shadow: none;"
        >
          <span class="btn-content">
            <span>Refresh</span>
            <em class="fas fa-sync-alt"></em>
          </span>
        </button> -->

        		     <app-common-button
 
          label="Refresh"
 
          title="Refresh "
 
          icon="fas fa-sync-alt"
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onRefresh($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

       
         <button
      mat-icon-button
      (click)="togglePanel($event, panel)"
    >
      <mat-icon>
        {{ panel.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>
    </button>
    </mat-expansion-panel-header>
    <div *ngIf="gridRowData && gridRowData.length > 0"
      [style.background-color]="backgroundColorScreen"
    >
    <ag-grid-angular
     style="height: 50vh;" id="Grid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" 
      [columnDefs]="columnDefs"
      [rowMultiSelectWithClick]="true"
      [animateRows]="true"
      [pagination]="true"
      [rowData]="gridRowData"
      [defaultColDef]="defaultColDef"
      [suppressPaginationPanel]="true"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true"
      [components]="components"
      (paginationChanged)="onPaginationChanged()"
      (gridReady)="onGridReady($event)"
       [rowClassRules]="rowClassRules"
        [getRowStyle]="getRowStyle"
      >
      </ag-grid-angular>
        <mat-toolbar
        class="agGridtoperDiv card"
        style="
          background: rgb(244 243 245);
             border: 1px solid #a9a9a9a8;
              margin-top: 0;
              box-shadow: none;
              border-radius: unset;
              border-top: none;
        "
      >
        <span class="example-spacer"></span>

        <!-- Create Template -->
        <!-- <button class="download-btn popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton" (click)="onCreateTemplate()">
          <em class="fas fa-file-alt"></em> Create Template
        </button> -->
        <!-- Create Template Button -->
        

        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@Targetpageno">Page No</mat-label>
            <input
              matInput
              type="text"
              (input)="onRunSearchChange($event.target.value)"
            />
          </mat-form-field>
        </div>
        <div class="selectRecordsDiv" style="width: 9.5%">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label i18n="@@Targetrecords" style="color: black"
              >Records</mat-label
            >
            <mat-select
              ngDefaultControl
              [(ngModel)]="RunpageSize"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onRunPageSizeChanged(value)"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
          style="box-shadow: none;"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onRunBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded"  style="box-shadow: none;">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onRunBtPrevious()"
              ></em>
            </li>
            <li>{{ RuncurrentPage }}/{{ RuntotalPages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onRunBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton" 
           style="box-shadow: none;"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onRunBtLast()"
          ></em>
        </div>
      </mat-toolbar>
    </div>
  </mat-expansion-panel>
  </div>

</ng-container>

</div>
<ng-container *ngIf="showProductInfoPage">
<!-- <app-product-info (goBack)="hiddeProductInfoPage()"></app-product-info> -->
<app-product-details [external]="true" [productId]="selectedProductIdFromGridToShowInfo" (back)="hiddeProductInfoPage()"></app-product-details>
</ng-container>